import type { AuthProps } from "features/auth";
import type { Artist } from "features/reviewable";
import { canEditProfile } from "./canEditProfile";

/**
 * Based on current user and state of artist profile, determine which profile to show
 */
const shouldShowBetaProfile = ({
  user,
  roles,
  artist,
}: {
  user?: AuthProps["user"];
  roles: AuthProps["roles"];
  artist?: Artist;
}) =>
  artist?.betaProfile === "PUBLISHED" ||
  (artist?.betaProfile === "CONVERTED" &&
    canEditProfile({ user, roles, artist }));

export { shouldShowBetaProfile };
